// Components
import { LegalPageContent } from '../../components/LegalPageContent/LegalPageContent';

export const EvaluationTermsPage = () => {
  return <LegalPageContent slug="evaluation-terms" fallbackTitle="Evaluation Terms of Service" />;
};
